import { NAMESPACE } from 'react/api/actions/base';

const PREFIX = 'STOP_DETAILS_POPUP';

export const STOP_DETAILS_POPUP_OPENED = `${NAMESPACE}/${PREFIX}_STOP_DETAILS_POPUP_OPENED`;
export const STOP_DETAILS_POPUP_CLOSED = `${NAMESPACE}/${PREFIX}_STOP_DETAILS_POPUP_CLOSED`;

export const REQUEST_STOP_DETAILS_POPUP_DATA_STARTED = `${NAMESPACE}/${PREFIX}_REQUEST_STOP_DETAILS_POPUP_DATA_STARTED`;
export const REQUEST_STOP_DETAILS_POPUP_DATA_COMPLETED = `${NAMESPACE}/${PREFIX}_REQUEST_STOP_DETAILS_POPUP_DATA_COMPLETED`;
export const REQUEST_STOP_DETAILS_POPUP_DATA_FAILED = `${NAMESPACE}/${PREFIX}_REQUEST_STOP_DETAILS_POPUP_DATA_FAILED`;

export const REQUEST_UPDATE_STOP_DETAILS_POPUP_DATA_STARTED = `${NAMESPACE}/${PREFIX}_REQUEST_UPDATE_STOP_DETAILS_POPUP_DATA_STARTED`;
export const REQUEST_UPDATE_STOP_DETAILS_POPUP_DATA_COMPLETED = `${NAMESPACE}/${PREFIX}_REQUEST_UPDATE_STOP_DETAILS_POPUP_DATA_COMPLETED`;
export const REQUEST_UPDATE_STOP_DETAILS_POPUP_DATA_FAILED = `${NAMESPACE}/${PREFIX}_REQUEST_UPDATE_STOP_DETAILS_POPUP_DATA_FAILED`;

export const GEOCODE_ENABLED = `${NAMESPACE}/${PREFIX}_GEOCODE_ENABLED`;
export const GEOCODE_DISABLED = `${NAMESPACE}/${PREFIX}_GEOCODE_DISABLED`;
export const GEOCODE_CANCELED = `${NAMESPACE}/${PREFIX}_GEOCODE_CANCELED`;
export const GEOCODE_SAVED = `${NAMESPACE}/${PREFIX}_GEOCODE_SAVED`;

export const GEOCODE_POPUP_OPENED = `${NAMESPACE}/${PREFIX}_GEOCODE_POPUP_OPENED`;

export const GOOGLE_SUGGESTIONS_REQUESTED = `${NAMESPACE}/${PREFIX}_GOOGLE_SUGGESTIONS_REQUESTED`;
export const GOOGLE_SUGGESTIONS_COMPLETED = `${NAMESPACE}/${PREFIX}_GOOGLE_SUGGESTIONS_COMPLETED`;
export const GOOGLE_SUGGESTIONS_FAILED = `${NAMESPACE}/${PREFIX}_GOOGLE_SUGGESTIONS_FAILED`;

export const EQUIPMENT_SUGGESTIONS_REQUESTED = `${NAMESPACE}/${PREFIX}_EQUIPMENT_SUGGESTIONS_REQUESTED`;
export const EQUIPMENT_SUGGESTIONS_COMPLETED = `${NAMESPACE}/${PREFIX}_EQUIPMENT_SUGGESTIONS_COMPLETED`;
export const EQUIPMENT_SUGGESTIONS_FAILED = `${NAMESPACE}/${PREFIX}_EQUIPMENT_SUGGESTIONS_FAILED`;

export const ZONES_ENABLED = `${NAMESPACE}/${PREFIX}_ZONES_ENABLED`;
export const ZONES_DISABLED = `${NAMESPACE}/${PREFIX}_ZONES_DISABLED`;

export const HEATMAPS_ENABLED = `${NAMESPACE}/${PREFIX}_HEATMAPS_ENABLED`;
export const HEATMAPS_DISABLED = `${NAMESPACE}/${PREFIX}_HEATMAPS_DISABLED`;

export const SIGNATURE_HEAT_MAP_ENABLED = `${NAMESPACE}/${PREFIX}_SIGNATURE_HEAT_MAP_ENABLED`;
export const SIGNATURE_HEAT_MAP_DISABLED = `${NAMESPACE}/${PREFIX}_SIGNATURE_HEAT_MAP_DISABLED`;

export const ARRIVAL_HEAT_MAP_ENABLED = `${NAMESPACE}/${PREFIX}_ARRIVAL_HEAT_MAP_ENABLED`;
export const ARRIVAL_HEAT_MAP_DISABLED = `${NAMESPACE}/${PREFIX}_ARRIVAL_HEAT_MAP_DISABLED`;

export const SIGNATURE_LOCATION_ENABLED = `${NAMESPACE}/${PREFIX}_SIGNATURE_LOCATION_ENABLED`;
export const SIGNATURE_LOCATION_DISABLED = `${NAMESPACE}/${PREFIX}_SIGNATURE_LOCATION_DISABLED`;

export const SIGNATURE_ACCURACY_ENABLED = `${NAMESPACE}/${PREFIX}_SIGNATURE_ACCURACY_ENABLED`;
export const SIGNATURE_ACCURACY_DISABLED = `${NAMESPACE}/${PREFIX}_SIGNATURE_ACCURACY_DISABLED`;

export const ARRIVAL_LOCATION_ENABLED = `${NAMESPACE}/${PREFIX}_ARRIVAL_LOCATION_ENABLED`;
export const ARRIVAL_LOCATION_DISABLED = `${NAMESPACE}/${PREFIX}_ARRIVAL_LOCATION_DISABLED`;

export const DEPARTURE_LOCATION_ENABLED = `${NAMESPACE}/${PREFIX}_DEPARTURE_LOCATION_ENABLED`;
export const DEPARTURE_LOCATION_DISABLED = `${NAMESPACE}/${PREFIX}_DEPARTURE_LOCATION_DISABLED`;

export const ARRIVAL_ACCURACY_ENABLED = `${NAMESPACE}/${PREFIX}_ARRIVAL_ACCURACY_ENABLED`;
export const ARRIVAL_ACCURACY_DISABLED = `${NAMESPACE}/${PREFIX}_ARRIVAL_ACCURACY_DISABLED`;

export const REQUEST_ARRIVAL_HEAT_MAP_STARTED = `${NAMESPACE}/${PREFIX}_REQUEST_ARRIVAL_HEAT_MAP_STARTED`;
export const REQUEST_ARRIVAL_HEAT_MAP_COMPLETED = `${NAMESPACE}/${PREFIX}_REQUEST_ARRIVAL_HEAT_MAP_COMPLETED`;
export const REQUEST_ARRIVAL_HEAT_MAP_FAILED = `${NAMESPACE}/${PREFIX}_REQUEST_ARRIVAL_HEAT_MAP_FAILED`;

export const REQUEST_SIGNATURE_HEAT_MAP_STARTED = `${NAMESPACE}/${PREFIX}_REQUEST_SIGNATURE_HEAT_MAP_STARTED`;
export const REQUEST_SIGNATURE_HEAT_MAP_COMPLETED = `${NAMESPACE}/${PREFIX}_REQUEST_SIGNATURE_HEAT_MAP_COMPLETED`;
export const REQUEST_SIGNATURE_HEAT_MAP_FAILED = `${NAMESPACE}/${PREFIX}_REQUEST_SIGNATURE_HEAT_MAP_FAILED`;

export const SIGNATURE_LOCATION_ADDED_TO_MAP = `${NAMESPACE}/${PREFIX}_SIGNATURE_LOCATION_ADDED_TO_MAP`;
export const SIGNATURE_LOCATION_REMOVED_FROM_MAP = `${NAMESPACE}/${PREFIX}_SIGNATURE_LOCATION_REMOVED_FROM_MAP`;

export const SIGNATURE_ACCURACY_ADDED_TO_MAP = `${NAMESPACE}/${PREFIX}_SIGNATURE_ACCURACY_ADDED_TO_MAP`;
export const SIGNATURE_ACCURACY_REMOVED_FROM_MAP = `${NAMESPACE}/${PREFIX}_SIGNATURE_ACCURACY_REMOVED_FROM_MAP`;

export const ARRIVAL_LOCATION_ADDED_TO_MAP = `${NAMESPACE}/${PREFIX}_ARRIVAL_LOCATION_ADDED_TO_MAP`;
export const ARRIVAL_LOCATION_REMOVED_FROM_MAP = `${NAMESPACE}/${PREFIX}_ARRIVAL_LOCATION_REMOVED_FROM_MAP`;

export const DEPARTURE_LOCATION_ADDED_TO_MAP = `${NAMESPACE}/${PREFIX}_DEPARTURE_LOCATION_ADDED_TO_MAP`;
export const DEPARTURE_LOCATION_REMOVED_FROM_MAP = `${NAMESPACE}/${PREFIX}_DEPARTURE_LOCATION_REMOVED_FROM_MAP`;

export const ARRIVAL_ACCURACY_ADDED_TO_MAP = `${NAMESPACE}/${PREFIX}_ARRIVAL_ACCURACY_ADDED_TO_MAP`;
export const ARRIVAL_ACCURACY_REMOVED_FROM_MAP = `${NAMESPACE}/${PREFIX}_ARRIVAL_ACCURACY_REMOVED_FROM_MAP`;

export const SIGNATURE_HEAT_MAP_ADDED_TO_MAP = `${NAMESPACE}/${PREFIX}_SIGNATURE_HEAT_MAP_ADDED_TO_MAP`;
export const SIGNATURE_HEAT_MAP_REMOVED_FROM_MAP = `${NAMESPACE}/${PREFIX}_SIGNATURE_HEAT_MAP_REMOVED_FROM_MAP`;

export const ARRIVAL_HEAT_MAP_ADDED_TO_MAP = `${NAMESPACE}/${PREFIX}_ARRIVAL_HEAT_MAP_ADDED_TO_MAP`;
export const ARRIVAL_HEAT_MAP_REMOVED_FROM_MAP = `${NAMESPACE}/${PREFIX}_ARRIVAL_HEAT_MAP_REMOVED_FROM_MAP`;

export const REQUEST_SIGNATURE_STARTED = `${NAMESPACE}/${PREFIX}_REQUEST_SIGNATURE_STARTED`;
export const REQUEST_SIGNATURE_COMPLETED = `${NAMESPACE}/${PREFIX}_REQUEST_SIGNATURE_COMPLETED`;
export const REQUEST_SIGNATURE_FAILED = `${NAMESPACE}/${PREFIX}_REQUEST_SIGNATURE_FAILED`;

export const SET_SELECTED_STOP_ID = 'SET_SELECTED_STOP_ID';

export const openStopDetailsPopup = (routeId, stopId) => ({
  type: STOP_DETAILS_POPUP_OPENED,
  payload: {
    routeId,
    stopId
  }
});

export const closeStopDetailsPopup = (routeId, stopId) => ({
  type: STOP_DETAILS_POPUP_CLOSED,
  payload: {
    routeId,
    stopId
  }
});

export const requestStopDetailsPopupData = (routeId, stopId, marker, map) => ({
  type: REQUEST_STOP_DETAILS_POPUP_DATA_STARTED,
  payload: {
    routeId,
    stopId,
    marker,
    map
  }
});

export const completeRequestStopDetailsPopupData = (routeId, stopId, stop) => ({
  type: REQUEST_STOP_DETAILS_POPUP_DATA_COMPLETED,
  payload: {
    routeId,
    stopId,
    stop
  }
});

export const failRequestStopDetailsPopupData = (routeId, stopId, error) => ({
  type: REQUEST_STOP_DETAILS_POPUP_DATA_FAILED,
  payload: {
    routeId,
    stopId,
    error
  }
});

export const enableGeocode = (routeId, stopId) => ({
  type: GEOCODE_ENABLED,
  payload: {
    routeId,
    stopId
  }
});

export const disableGeocode = (routeId, stopId) => ({
  type: GEOCODE_DISABLED,
  payload: {
    routeId,
    stopId
  }
});

export const cancelGeocode = (routeId, stopId) => ({
  type: GEOCODE_CANCELED,
  payload: {
    routeId,
    stopId
  }
});

export const saveGeocode = (routeId, stopId) => ({
  type: GEOCODE_SAVED,
  payload: {
    routeId,
    stopId
  }
});

export const requestGoogleSuggestions = (routeId, stopId) => ({
  type: GOOGLE_SUGGESTIONS_REQUESTED,
  payload: {
    routeId,
    stopId
  }
});

export const completeGoogleSuggestions = (routeId, stopId, suggestions) => ({
  type: GOOGLE_SUGGESTIONS_COMPLETED,
  payload: {
    routeId,
    stopId,
    suggestions
  }
});

export const failGoogleSuggestions = (routeId, stopId, error) => ({
  type: GOOGLE_SUGGESTIONS_FAILED,
  payload: {
    routeId,
    stopId,
    error
  }
});

export const requestEquipmentSuggestions = (routeId, stopId) => ({
  type: EQUIPMENT_SUGGESTIONS_REQUESTED,
  payload: {
    routeId,
    stopId
  }
});

export const completeEquipmentSuggestions = (routeId, stopId, equipmentSuggestions) => ({
  type: EQUIPMENT_SUGGESTIONS_COMPLETED,
  payload: {
    routeId,
    stopId,
    equipmentSuggestions
  }
});

export const failEquipmentSuggestions = (routeId, stopId, error) => ({
  type: EQUIPMENT_SUGGESTIONS_FAILED,
  payload: {
    routeId,
    stopId,
    error
  }
});

export const openPopup = (routeId, stopId, event) => ({
  type: GEOCODE_POPUP_OPENED,
  payload: {
    routeId,
    stopId,
    event
  }
});

export const requestSignature = (routeId, stopId) => ({
  type: REQUEST_SIGNATURE_STARTED,
  payload: {
    routeId,
    stopId
  }
});

export const completeRequestSignature = (routeId, stopId, signature) => ({
  type: REQUEST_SIGNATURE_COMPLETED,
  payload: {
    routeId,
    stopId,
    signature
  }
});

export const failRequestSignature = (routeId, stopId, error) => ({
  type: REQUEST_SIGNATURE_FAILED,
  payload: {
    routeId,
    stopId,
    error
  }
});

export const enableZones = (routeId, stopId) => ({
  type: ZONES_ENABLED,
  payload: {
    routeId,
    stopId
  }
});

export const disableZones = (routeId, stopId) => ({
  type: ZONES_DISABLED,
  payload: {
    routeId,
    stopId
  }
});

export const enableHeatMaps = (routeId, stopId) => ({
  type: HEATMAPS_ENABLED,
  payload: {
    routeId,
    stopId
  }
});

export const disableHeatMaps = (routeId, stopId) => ({
  type: HEATMAPS_DISABLED,
  payload: {
    routeId,
    stopId
  }
});

export const enableSignatureHeatMap = (routeId, stopId) => ({
  type: SIGNATURE_HEAT_MAP_ENABLED,
  payload: {
    routeId,
    stopId
  }
});

export const disableSignatureHeatMap = (routeId, stopId) => ({
  type: SIGNATURE_HEAT_MAP_DISABLED,
  payload: {
    routeId,
    stopId
  }
});

export const enableArrivalHeatMap = (routeId, stopId) => ({
  type: ARRIVAL_HEAT_MAP_ENABLED,
  payload: {
    routeId,
    stopId
  }
});

export const disableArrivalHeatMap = (routeId, stopId) => ({
  type: ARRIVAL_HEAT_MAP_DISABLED,
  payload: {
    routeId,
    stopId
  }
});

export const enableSignatureLocation = (routeId, stopId) => ({
  type: SIGNATURE_LOCATION_ENABLED,
  payload: {
    routeId,
    stopId
  }
});

export const disableSignatureLocation = (routeId, stopId) => ({
  type: SIGNATURE_LOCATION_DISABLED,
  payload: {
    routeId,
    stopId
  }
});

export const enableSignatureAccuracy = (routeId, stopId) => ({
  type: SIGNATURE_ACCURACY_ENABLED,
  payload: {
    routeId,
    stopId
  }
});

export const disableSignatureAccuracy = (routeId, stopId) => ({
  type: SIGNATURE_ACCURACY_DISABLED,
  payload: {
    routeId,
    stopId
  }
});

export const enableArrivalLocation = (routeId, stopId) => ({
  type: ARRIVAL_LOCATION_ENABLED,
  payload: {
    routeId,
    stopId
  }
});

export const disableArrivalLocation = (routeId, stopId) => ({
  type: ARRIVAL_LOCATION_DISABLED,
  payload: {
    routeId,
    stopId
  }
});

export const enableDepartureLocation = (routeId, stopId) => ({
  type: DEPARTURE_LOCATION_ENABLED,
  payload: {
    routeId,
    stopId
  }
});

export const disableDepartureLocation = (routeId, stopId) => ({
  type: DEPARTURE_LOCATION_DISABLED,
  payload: {
    routeId,
    stopId
  }
});

export const enableArrivalAccuracy = (routeId, stopId) => ({
  type: ARRIVAL_ACCURACY_ENABLED,
  payload: {
    routeId,
    stopId
  }
});

export const disableArrivalAccuracy = (routeId, stopId) => ({
  type: ARRIVAL_ACCURACY_DISABLED,
  payload: {
    routeId,
    stopId
  }
});

export const requestSignatureHeatMap = (routeId, stopId) => ({
  type: REQUEST_SIGNATURE_HEAT_MAP_STARTED,
  payload: {
    routeId,
    stopId
  }
});

export const completeRequestSignatureHeatMap = (routeId, stopId, heatMapData) => ({
  type: REQUEST_SIGNATURE_HEAT_MAP_COMPLETED,
  payload: {
    routeId,
    stopId,
    heatMapData
  }
});

export const failRequestSignatureHeatMap = (routeId, stopId) => ({
  type: REQUEST_SIGNATURE_HEAT_MAP_FAILED,
  payload: {
    routeId,
    stopId
  }
});

export const requestArrivalHeatMap = (routeId, stopId) => ({
  type: REQUEST_ARRIVAL_HEAT_MAP_STARTED,
  payload: {
    routeId,
    stopId
  }
});

export const completeRequestArrivalHeatMap = (routeId, stopId, heatMapData) => ({
  type: REQUEST_ARRIVAL_HEAT_MAP_COMPLETED,
  payload: {
    routeId,
    stopId,
    heatMapData
  }
});

export const failRequestArrivalHeatMap = (routeId, stopId, error) => ({
  type: REQUEST_ARRIVAL_HEAT_MAP_FAILED,
  payload: {
    routeId,
    stopId,
    error
  }
});

export const addSignatureLocationToMap = (routeId, stopId) => ({
  type: SIGNATURE_LOCATION_ADDED_TO_MAP,
  payload: {
    routeId,
    stopId
  }
});

export const removeSignatureLocationFromMap = (routeId, stopId) => ({
  type: SIGNATURE_LOCATION_REMOVED_FROM_MAP,
  payload: {
    routeId,
    stopId
  }
});

export const addSignatureAccuracyToMap = (routeId, stopId) => ({
  type: SIGNATURE_ACCURACY_ADDED_TO_MAP,
  payload: {
    routeId,
    stopId
  }
});

export const removeSignatureAccuracyFromMap = (routeId, stopId) => ({
  type: SIGNATURE_ACCURACY_REMOVED_FROM_MAP,
  payload: {
    routeId,
    stopId
  }
});

export const addArrivalLocationToMap = (routeId, stopId) => ({
  type: ARRIVAL_LOCATION_ADDED_TO_MAP,
  payload: {
    routeId,
    stopId
  }
});

export const removeArrivalLocationFromMap = (routeId, stopId) => ({
  type: ARRIVAL_LOCATION_REMOVED_FROM_MAP,
  payload: {
    routeId,
    stopId
  }
});

export const addDepartureLocationToMap = (routeId, stopId) => ({
  type: DEPARTURE_LOCATION_ADDED_TO_MAP,
  payload: {
    routeId,
    stopId
  }
});

export const removeDepartureLocationFromMap = (routeId, stopId) => ({
  type: DEPARTURE_LOCATION_REMOVED_FROM_MAP,
  payload: {
    routeId,
    stopId
  }
});

export const addArrivalAccuracyToMap = (routeId, stopId) => ({
  type: ARRIVAL_ACCURACY_ADDED_TO_MAP,
  payload: {
    routeId,
    stopId
  }
});

export const removeArrivalAccuracyFromMap = (routeId, stopId) => ({
  type: ARRIVAL_ACCURACY_REMOVED_FROM_MAP,
  payload: {
    routeId,
    stopId
  }
});

export const addSignatureHeatMapToMap = (routeId, stopId, coordinates) => ({
  type: SIGNATURE_HEAT_MAP_ADDED_TO_MAP,
  payload: {
    routeId,
    stopId,
    coordinates
  }
});

export const removeSignatureHeatMapFromMap = (routeId, stopId) => ({
  type: SIGNATURE_HEAT_MAP_REMOVED_FROM_MAP,
  payload: {
    routeId,
    stopId
  }
});

export const addArrivalHeatMapToMap = (routeId, stopId, coordinates) => ({
  type: ARRIVAL_HEAT_MAP_ADDED_TO_MAP,
  payload: {
    routeId,
    stopId,
    coordinates
  }
});

export const removeArrivalHeatMapFromMap = (routeId, stopId) => ({
  type: ARRIVAL_HEAT_MAP_REMOVED_FROM_MAP,
  payload: {
    routeId,
    stopId
  }
});

export const updateStopDetailsPopupData = (routeId, stopId) => ({
  type: REQUEST_UPDATE_STOP_DETAILS_POPUP_DATA_STARTED,
  payload: {
    routeId,
    stopId
  }
});

export const completeUpdateStopDetailsPopupData = (routeId, stopId, stop) => ({
  type: REQUEST_UPDATE_STOP_DETAILS_POPUP_DATA_COMPLETED,
  payload: {
    routeId,
    stopId,
    stop
  }
});

export const failUpdateStopDetailsPopupData = (routeId, stopId, error) => ({
  type: REQUEST_UPDATE_STOP_DETAILS_POPUP_DATA_FAILED,
  payload: {
    routeId,
    stopId,
    error
  }
});

export const setSelectedStopId = stopId => ({
  type: SET_SELECTED_STOP_ID,
  payload: {
    stopId
  }
});
